<template>
  <div class="sso-page d-flex align-items-center justify-content-center">
    <div class="sso-card text-center">
      <h1 class="sso-title">Automan 登录中</h1>
      <p class="sso-text">{{ statusText }}</p>
      <button v-if="failed" type="button" class="btn btn-primary mt-3" @click="goLogin">
        返回登录页
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AutomanSsoView',
  data() {
    return {
      statusText: '正在校验登录凭证…',
      failed: false
    }
  },
  mounted() {
    this.exchange()
  },
  methods: {
    goLogin() {
      window.location.hash = '#/'
    },
    readTicket() {
      const hash = String(window.location.hash || '')
      const qIndex = hash.indexOf('?')
      if (qIndex >= 0) {
        const params = new URLSearchParams(hash.slice(qIndex + 1))
        const fromHash = (params.get('ticket') || '').trim()
        if (fromHash) return fromHash
      }
      const fromRoute = String((this.$route && this.$route.query && this.$route.query.ticket) || '').trim()
      return fromRoute
    },
    exchange() {
      const ticket = this.readTicket()
      if (!ticket) {
        this.failed = true
        this.statusText = '缺少 ticket，请从游戏重新进入或使用账号密码登录'
        return
      }
      fetch('/api/auth/automan-sso', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': '1'
        },
        body: JSON.stringify({ ticket })
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.code !== 200) {
            this.failed = true
            this.statusText = res.message || res.msg || 'SSO 登录失败'
            return
          }
          const user = res.data || {}
          const role = String(user.role || '').trim().toLowerCase()
          if (role !== 'student') {
            this.failed = true
            this.statusText = '仅学员可通过 Automan SSO 进入'
            return
          }
          localStorage.setItem('exam_user', JSON.stringify(user))
          window.dispatchEvent(new Event('auth-changed'))
          window.dispatchEvent(new Event('exam-login-success-toast'))
          this.statusText = '登录成功，正在进入学员首页…'
          window.location.hash = '#/student/home'
        })
        .catch(() => {
          this.failed = true
          this.statusText = '网络异常，请稍后重试'
        })
    }
  }
}
</script>

<style scoped>
.sso-page {
  min-height: 100vh;
  padding: 24px;
  background: linear-gradient(180deg, #ffffff 0%, #f0f9ff 45%, #f8fafc 100%);
}
.sso-card {
  width: min(100%, 420px);
  padding: 36px 28px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid #e0f2fe;
  box-shadow: 0 12px 40px -8px rgba(14, 165, 233, 0.12);
}
.sso-title {
  margin: 0 0 12px;
  font-size: 1.35rem;
  font-weight: 700;
  color: #1e293b;
}
.sso-text {
  margin: 0;
  color: #64748b;
  line-height: 1.5;
}
</style>
